import React from 'react';

const Footer = (props) => {
	return (
		<footer>
			<p>Made with ♥ by <a href="https://www.tramino.de/">Tramino</a> in <a href="http://www.oberstdorf.de/">Oberstdorf</a>.</p>
			<p>Powered by <a href="https://www.tramino.de/opensource">great and open libraries</a>.</p>
		</footer>
	)
}

export default Footer;



/** WEBPACK FOOTER **
 ** ../ibe/components/Footer.js
 **/